var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCInfos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_466_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0014 29.999C12.0344 29.999 9.13406 29.1191 6.66709 27.4708C4.20012 25.8224 2.27734 23.4795 1.14192 20.7383C0.00649987 17.9972 -0.290578 14.9809 0.288255 12.0709C0.867088 9.1609 2.29584 6.4879 4.39382 4.38992C6.49181 2.29193 9.16481 0.863182 12.0748 0.284349C14.9848 -0.294485 18.0011 0.00259362 20.7422 1.13802C23.4834 2.27344 25.8263 4.19621 27.4747 6.66318C29.123 9.13015 30.0029 12.0305 30.0029 14.9975C29.9991 18.975 28.4174 22.7885 25.6049 25.601C22.7924 28.4135 18.9789 29.9952 15.0014 29.999ZM15.0014 3.22028C12.6714 3.21971 10.3936 3.91013 8.45598 5.2042C6.51838 6.49827 5.00805 8.33787 4.116 10.4904C3.22395 12.6428 2.99026 15.0115 3.44448 17.2968C3.89869 19.5821 5.02041 21.6814 6.66778 23.3292C8.31514 24.9769 10.4141 26.0992 12.6993 26.5539C14.9845 27.0087 17.3533 26.7756 19.506 25.8841C21.6587 24.9925 23.4986 23.4826 24.7932 21.5454C26.0877 19.6081 26.7787 17.3304 26.7787 15.0004C26.7757 11.8775 25.534 8.8834 23.326 6.67494C21.1181 4.46648 18.1243 3.22406 15.0014 3.22028V3.22028Z",
    fill: "#F07F3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.098 22.5843H13.5735V12.2806H17.5887V15.2164H16.098V22.5843ZM16.1922 11.1383H13.4792V7.42578H16.1922V11.1383Z",
    fill: "#F07F3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_466_73"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCInfos);
export default __webpack_public_path__ + "static/media/c_infos.f1b1b9b219db6c14ac43ae623fa027b8.svg";
export { ForwardRef as ReactComponent };